"use client";

import { type ReactNode } from "react";
import { BlankLayout } from "src/app/(app)/_layout/blank-layout";

const BlankLayoutWrapper = ({ children }: { children: ReactNode }) => {
  return <BlankLayout>{children}</BlankLayout>;
};

export default BlankLayoutWrapper;
